import { Component } from '@angular/core';

@Component({
  selector: 'app-equipment',
  templateUrl: './equipment.component.html',
  // styleUrl: './equipment.component.scss',
  providers: [Location]
})
export class EquipmentComponent {

}
